/* eslint-disable */
import { memo, useEffect, useState, useMemo } from "react";
import { Box, Button, styled, useTheme, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Typography } from "@mui/material";
import { useLocation, Link, useSearchParams, useNavigate } from "react-router-dom";
import { GetScrapyData } from "../../../hooks/scrapyData";
import { useSelector } from "react-redux";
const NavbarMenuWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  "& .navButton": {
    textTransform: "none",
    fontSize: "11px",
    fontWeight: 400,
    padding: "6px 14px",
    borderRadius: "8px",
    color: theme.palette.text.primary,
    transition: "all 0.2s ease",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },

    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary, // ⬅️ IMPORTANT
      // transform: "translateY(-1px)",
    },

    /* ✅ ACTIVE STATE */
    "&.active": {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      fontWeight: 600,

      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        color: "#fff",
      },
    },
  },
  "&.topNavMenu a": {
    padding: "5px 15px",
    "@media screen and (min-width:1200px) and (max-width:1280px)": {
      fontSize: "8px",
    },
    "@media screen and (min-width:1280px) and (max-width:1396px)": {
      fontSize: "10px",
    },
    "@media screen and (min-width:1396px) and (max-width:1510px)": {
      fontSize: "12px",
    },
    "@media screen and (min-width:1536px) ": {
      fontSize: "10px",
    },
  },
  "@media screen and (max-width:1199px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px",
    gap: "10px",
  },
  "@media screen and (min-width:1200px) and (max-width:1370px)": {
    gap: "0px",
  },
  "& > a": {
    "@media screen and (min-width:1200px) and (max-width:1370px)": {
      fontSize: "10px",
      padding: "5px 5px",
    },
    "@media screen and (min-width:1371px) and (max-width:1510px)": {
      fontSize: "11px",
      padding: "5px 11px",
    },
    "@media screen and (min-width:1536px) ": {
      fontSize: "10px",
    },
    "&.MuiButton-colorInherit:hover": {
      color: theme.palette.primary.main,
    },
  },
  "& button": {
    backgroundColor: "transparent",
    border: "none",
    color: theme.palette.text.primary,
    "&:hover": { backgroundColor: "transparent" },
    "&:focus": { outline: "none" },
    "&.Mui-selected": { backgroundColor: "transparent", color: theme.palette.primary.main, fontWeight: "600" },
    "& span.MuiTouchRipple-root": { display: "none" },
  },
  "& h4": {
    backgroundColor: theme.palette.primary.main,
    padding: "0px 10px 1px",
    borderRadius: "5px",
    color: "#ffffff",
    fontWeight: 600,
    whiteSpace: "nowrap",
    maxWidth: "260px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "default",
  },
}));

const customPatterns = [
  /\/projects\/[^/]+\/[^/]+$/,
  /\/project-detail\/[^/]+$/,
  /\/uptime-monitoring\/[^/]+$/,
  /\/projects\/report\/desktop\/([^/]+)\/([^/]+)$/,
  /\/projects\/report\/mobile\/([^/]+)\/([^/]+)$/,
];

const allowedRoles = ["SUPERADMIN", "COORDINATOR"];
function AppDD({ setAlignment, setShowDrawer }) {
  const { scrapyData, isVerified } = GetScrapyData();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const menu = searchParams.get("menu");
  const currentPath = location.pathname;

  // Helper: check if current path matches a nav tab (by menu param OR child routes)
  const isNavActive = (menuKey, childPaths = []) =>
    menu === menuKey || childPaths.some(cp => currentPath.startsWith(cp));
  const { userData } = useSelector(state => state.reducer);
  const theme = useTheme();
  const [anchorElAd, setAnchorElAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [upgradeDialogOpen, setUpgradeDialogOpen] = useState(false);
  const [blockedRoute, setBlockedRoute] = useState("");

  const customizer = useSelector(state => state.customizer);
  const navigate = useNavigate();

  const openAd = anchorElAd;
  const handleAnalyticDashboardClick = event => {
    setAnchorElAd(event.currentTarget);
  };
  const handleCloseAd = () => {
    setAnchorElAd(null);
    setShowDrawer && setShowDrawer(false);
  };

  const [urlParameters, setUrlParameters] = useState({
    srapySessionData: [],
    projectName: "",
    projectId: "",
  });
  const ButtonTabHover = pathname => {
    try {
      if (pathname.includes("uptime-monitoring/")) {
        setAlignment("Uptime");
      }
      if (pathname.includes("projects/")) {
        setAlignment("Overview");
      }
      if (pathname.includes("project-detail/")) {
        setAlignment("Site");
      }
      if (pathname.includes("/projects/report/desktop/")) {
        setAlignment("Website");
      }
      if (pathname.includes("/keywordsDashboard")) {
        setAlignment("Keyword");
      }
      if (pathname.includes("/ga-analytics")) {
        setAlignment("ga-analytics");
      }
      // if (pathname.includes("/google-trends")) {
      //   setAlignment("Google Trends");
      // }
    } catch (e) {
      console.log(e);
    }
  };
  const extractProjectIDFromURL = (pathname, search) => {
    const urlSearchParams = new URLSearchParams(search);
    const originValue = urlSearchParams.get("origin");

    if (originValue) {
      return originValue;
    }
    const customPattern = /\/projects\/report\/desktop\/([^/]+)\/([^/]+)$/ || /\/projects\/report\/mobile\/([^/]+)\/([^/]+)$/;

    const customPathMatch = pathname.match(customPattern);

    if (customPathMatch) {
      const secondPart = customPathMatch[2];
      return secondPart;
    }

    const pathMatch = pathname.match(/\/(?:|projects|uptime-monitoring)\/([^/]+)/);

    if (pathMatch && pathMatch[1]) {
      return pathMatch[1];
    }

    return null;
  };

  const showButtons = useMemo(() => customPatterns.some(pattern => pattern.test(location.pathname)), [location.pathname]);

  useEffect(() => {
    if (!scrapyData.length) return;

    setLoading(false);
    ButtonTabHover(location.pathname, location.search);

    if (showButtons) {
      const projectID = extractProjectIDFromURL(location.pathname, location.search);
      const matchingProject = scrapyData.find(project => project.id === projectID);
      const { srapySessionData, projectName, id } = matchingProject || {};

      setUrlParameters({
        srapySessionData: srapySessionData || [],
        projectName: projectName || "",
        projectId: id || "",
      });
    }
    // eslint-disable-next-line
  }, [scrapyData, location.search, location.pathname, showButtons]);

  useEffect(() => {
    if (isVerified) {
      navigate("/project-config");
      setLoading(false);
    }
  }, [isVerified]);

  const handleRestrictedClick = targetRoute => {
    const isFreemium = userData?.subscriptionCredits?.subscriptionType === "FREEMIUM";

    if (isFreemium) {
      setBlockedRoute(targetRoute);
      setUpgradeDialogOpen(true);
      return;
    }

    navigate(targetRoute);
  };

  return (
    <>
      {loading ? (
        <CircularProgress size="25.4" />
      ) : (
        <NavbarMenuWrapper className={`${customizer?.isCollapse && "topNavMenu"}`}>
          <>
            {/* <Button
              color={menu === "dashboard" ? "primary" : "inherit"}
              component={Link}
              to={`/dashboard?menu=dashboard`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Dashboard
            </Button> */}
            <Button
              variant="text"
              className={`navButton ${isNavActive("dashboard", ["/dashboard", "/websitelist", "/projects/"]) ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                navigate("/dashboard?menu=dashboard");
              }}
            >
              Dashboard
            </Button>
            {/* <Button
              color={menu === "headerSiteAudit" ? "primary" : "inherit"}
              component={Link}
              to={
                userData?.subscriptionCredits?.subscriptionType === "FREEMIUM" || (userData?.subscriptionCredits?.siteAudit || 0) === 0
                  ? "/payments"
                  : "/siteAudit?menu=headerSiteAudit"
              }
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Site Audit
            </Button> */}
            <Button
              className={`navButton ${isNavActive("headerSiteAudit", ["/siteAudit", "/project-detail/", "/project-inner-detail/", "/issue-details/", "/issuesflag/", "/crawl-table/", "/crawl-progress/"]) ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                handleRestrictedClick("/siteAudit?menu=headerSiteAudit");
              }}
            >
              Site Audit
            </Button>
            {/* <Button
              color={menu === "headerMonitoring" ? "primary" : "inherit"}
              component={Link}
              to={`/uptimeMonitoring?menu=headerMonitoring`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Uptime Monitoring
            </Button> */}
            <Button
              variant="text"
              className={`navButton ${isNavActive("headerMonitoring", ["/uptimeMonitoring", "/uptime-monitoring/", "/downtime-monitoring/", "/uptime-setting/"]) ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                navigate("/uptimeMonitoring?menu=headerMonitoring");
              }}
            >
              Uptime Monitoring
            </Button>
            {/* <Button
              color={menu === "performanceDashboard" ? "primary" : "inherit"}
              component={Link}
              to={`/performanceDashboard?menu=performanceDashboard`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Performance Dashboard
            </Button> */}
            <Button
              variant="text"
              className={`navButton ${isNavActive("performanceDashboard", ["/performanceDashboard", "/websitePerformance/", "/performanceChartboard"]) ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                navigate("/performanceDashboard?menu=performanceDashboard");
              }}
            >
              Performance Dashboard
            </Button>

            {/* <Button
              color={menu === "headerKeywords" ? "primary" : "inherit"}
              component={Link}
              to={
                userData?.subscriptionCredits?.subscriptionType === "FREEMIUM" || (userData?.subscriptionCredits?.blogGeneration || 0) === 0
                  ? "/payments"
                  : "/keywordsDashboard?menu=headerKeywords"
              }
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Blog Generator
            </Button> */}
            {/* {userData && userData.role && allowedRoles.includes(userData.role) && (
              <Button
                color={menu === "headerAnalyticDashboard" ? "primary" : "inherit"}
                component={Link}
                to={`/analyticDashboard?menu=headerAnalyticDashboard`}
                onClick={() => {
                  setShowDrawer && setShowDrawer(false);
                }}
              >
                Analytic Dashboard
              </Button>
            )} */}
            {userData?.role && allowedRoles.includes(userData.role) && (
              <Button
                variant="text"
                className={`navButton ${isNavActive("headerAnalyticDashboard", ["/analyticDashboard"]) ? "active" : ""}`}
                onClick={() => {
                  setShowDrawer && setShowDrawer(false);
                  navigate("/analyticDashboard?menu=headerAnalyticDashboard");
                }}
              >
                Analytic Dashboard
              </Button>
            )}
            {/* <Button
              color={menu === "headerKeywordReserch" ? "primary" : "inherit"}
              component={Link}
              to={
                userData?.subscriptionCredits?.subscriptionType === "FREEMIUM" || (userData?.subscriptionCredits?.keywordResearch || 0) === 0
                  ? "/payments"
                  : "/keyword-reserch?menu=headerKeywordReserch"
              }
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              Keyword Research
            </Button> */}
            {/* <Button
              className={`navButton ${menu === "headerKeywordReserch" ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                handleRestrictedClick("/keyword-reserch?menu=headerKeywordReserch");
              }}
            >
              Keyword Research
            </Button> */}

            {/* <Button
              color={menu === "headerAiBlogGenerator" ? "primary" : "inherit"}
              component={Link}
              to={
                userData?.subscriptionCredits?.subscriptionType === "FREEMIUM" || (userData?.subscriptionCredits?.aiBlogGenerate || 0) === 0
                  ? "/payments"
                  : "/ai-blog-generator?menu=headerAiBlogGenerator"
              }
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
              }}
            >
              AI blog generate
            </Button> */}
            <Button
              className={`navButton ${isNavActive("headerAiBlogGenerator", ["/ai-blog-generator", "/ai-blog-writer", "/content-score", "/content-edit/", "/blog-titles", "/blog-paragraphs", "/blog-headings", "/edit-blog", "/keywordsDashboard", "/urlKeywords", "/generated-blogs", "/keyword-reserch", "/keyword-ranking"]) ? "active" : ""}`}
              onClick={() => {
                setShowDrawer && setShowDrawer(false);
                handleRestrictedClick("/ai-blog-generator?menu=headerAiBlogGenerator");
              }}
            >
              AI Content & SEO Hub
            </Button>

              <Button
                className={`navButton ${isNavActive("headerGoogleAnalytics", ["/ga-analytics", "/analyticDashboard"]) ? "active" : ""}`}
                onClick={() => {
                  setShowDrawer && setShowDrawer(false);
                  handleRestrictedClick("/ga-analytics?menu=headerGoogleAnalytics");
                }}
              >
                SEO Analytics Dashboard
              </Button>

            {/* <Button color={menu === "contentScore" ? "primary" : "inherit"} component={Link} to={"/content-score?menu=contentScore"}>
              Content Score
            </Button> */}
            <Dialog open={upgradeDialogOpen} onClose={() => setUpgradeDialogOpen(false)} maxWidth="xs" fullWidth>
              <DialogTitle>Upgrade Required 🚀</DialogTitle>

              <DialogContent>
                <Typography sx={{ mt: 1 }}>
                  You are currently on the <strong>Freemium</strong> plan.
                  <br />
                  Upgrade your plan to unlock this feature and enjoy more benefits.
                </Typography>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => {
                    setUpgradeDialogOpen(false);
                    navigate("/dashboard?menu=dashboard");
                  }}
                  color="inherit"
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  onClick={() => {
                    setUpgradeDialogOpen(false);
                    navigate("/payments");
                  }}
                >
                  View Plans
                </Button>
              </DialogActions>
            </Dialog>
          </>
        </NavbarMenuWrapper>
      )}
    </>
  );
}

export default memo(AppDD);
